/**
 * Sets up the Fancybox event handler for the warranty plan details link.
 * @returns {undefined}
 */
const warrantyPlanDetailsLink = function() {
	$(document.body).on('click', '.extended-warranty-offers-inner-container .plan-details-link', function(event) {
		event.preventDefault();
		$.fancybox({
			autoCenter: true,
			autoSize: true,
			fitToView: true,
			href: event.currentTarget.href,
			padding: 0,
			type: 'iframe'
		});
	});
};

export default warrantyPlanDetailsLink;
